export class DialogModel {
    constructor(public title: string, public message: string) { }
}
